import React, { lazy } from 'react';

import { canViewCampusInventories } from '../shared/helper';

const HazardSignPage = lazy(() => import('./containers/HazardSignPage'));
const BuildingListPage = lazy(() => import('./containers/BuildingListPage'));
const BuildingPage = lazy(() => import('./containers/BuildingPage'));
const RoomSuiteEditPage = lazy(() => import('./containers/RoomSuiteEditPage'));
const RoomSuitesInBuildingPage = lazy(() => import('./containers/RoomSuitesInBuildingPage'));
const RoomSignOptionsPage = lazy(() => import('./containers/RoomSignOptionsPage'));

const routes = {
  settings: {
    helpCategories: ['hazard-sign'],
  },
  auth: ({ profile } = {}) => Boolean(profile),
  routes: [
    {
      path: [
        '/hazard-sign/building/:buildingId/room/:roomId/sign',
        '/hazard-sign/building/:buildingId/suite/:suiteId/sign',
      ],
      exact: true,
      render: () => <HazardSignPage />,
    },
    {
      path: ['/hazard-sign/building/:buildingId/room/:roomId'],
      exact: true,
      render: () => <RoomSignOptionsPage />,
    },
    {
      path: ['/hazard-sign/building/:buildingId/suite/:suiteId'],
      exact: true,
      auth: ({ profile }) => canViewCampusInventories(profile.campusCode, profile),
      render: () => <RoomSuiteEditPage />,
    },
    {
      path: ['/hazard-sign/building/:buildingId/suite'],
      exact: true,
      auth: ({ profile }) => canViewCampusInventories(profile.campusCode, profile),
      render: () => <RoomSuitesInBuildingPage />,
    },
    {
      path: ['/hazard-sign/building/:buildingId'],
      exact: true,
      auth: ({ profile }) => canViewCampusInventories(profile.campusCode, profile),
      render: () => <BuildingPage />,
    },
    {
      path: ['/hazard-sign/building'],
      exact: true,
      auth: ({ profile }) => canViewCampusInventories(profile.campusCode, profile),
      render: () => <BuildingListPage />,
    },
  ],
};

export default routes;
